import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

import type { CSSProperties } from 'react';

/**
 * No `next-themes`: it would own theme state itself and ignore the `.dark` class the
 * preferences store toggles. Theme is passed in by the caller; `packages/ui` must not
 * depend on app state. Inline styles use the bare `--popover`/`--border`/`--radius`
 * properties: `--color-*`/`--radius-lg` are `@theme inline`-only and resolve to nothing.
 */
const Toaster = ({ theme = 'light', ...props }: ToasterProps) => {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
// Re-exported so callers depend on this module boundary instead of `sonner` directly:
// this file is the single owner of the toast surface.
export { toast } from 'sonner';
